import clsx from "clsx";

import { Button } from "common/components/ui/Button";
import { trackMetaPixel, trackMixpanel } from "common/helpers/utils";

interface NavigationButtonsProps {
  currentQuestionId: string;
  currentQuestionIndex: number;
  totalQuestions: number;
  isNextDisabled: boolean;
  isSubmitting: boolean;
  handleBack: () => void;
}

export default function NavigationButtons({
  currentQuestionId,
  currentQuestionIndex,
  totalQuestions,
  handleBack,
  isNextDisabled,
  isSubmitting,
}: NavigationButtonsProps) {
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;

  function handleNextClick() {
    if (isLastQuestion) {
      trackMetaPixel("track", "Lead");
    }
    const eventName = `onboarding_survey_${currentQuestionId}`;
    trackMixpanel(eventName);
  }

  return (
    <div
      className={clsx([
        "flex w-full items-center gap-4",
        currentQuestionIndex !== 0 ? "justify-between" : "justify-end",
      ])}
    >
      {currentQuestionIndex !== 0 && (
        <Button variant="secondary-black" onClick={handleBack}>
          Back
        </Button>
      )}

      <Button
        type="submit"
        disabled={isNextDisabled}
        isLoading={isSubmitting}
        onClick={handleNextClick}
      >
        {isLastQuestion ? "Finish" : "Next"}
      </Button>
    </div>
  );
}
